import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchInternalRepatriationReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getFluxVolumeOeReport',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, {
    focals: payload.params.focals,
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
  });
};

export default apiFetchInternalRepatriationReport;
